import React from 'react';

import { PortfolioAccountsCard } from './PortfolioAccountsCard';

/** Wealth tab — synced investment accounts with edit / delete. */
export function EditablePortfolioList() {
  return <PortfolioAccountsCard title="Active investments" category="investment" />;
}
